module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAMAAAD+iNU2AAAAAXNSR0IB2cksfwAAADNQTFRFAAAAlZiclpmdlJiclJShlJqalpicl5mbl5qal5iclpiclZqalZqalZWelZqdl5qdlZqcZA7jhgAAABF0Uk5TAE2ZQxMmfHNMkIY6MB1gVmrh46jOAAAAaElEQVR4nG2PQQ6AMAgEKZZCVdT/v9YFrTHRuSyTkLAQgcLBFCNVEWlqZtowVer8Zh7LF4W+viDXzn1FLnBBkrISUn7cX16jQfjGe+btXrjIcDSyxs2yDdDnvKYfj2/pPl6YnS5cgrQTXmgCz7FURJsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/v2/delete-icon.png
// module id = 298
// module chunks = 33